import { ADD_ACTION, GET_ACTION, GET_ACTIONS, DELETE_ACTION } from './types';
import axios from '../utils/axios';
import { getContactActivities } from './activity';

export const addAction = (formData, id) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const res = await axios.post(
      `/api/action/contactID/${id}`,
      formData,
      config
    );
    dispatch({
      type: ADD_ACTION,
      payload: res.data
    });
    dispatch(getNextAction(res.data._id));
    dispatch(getContactActivities(res.data._id));
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const editAction = (formData, id) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    console.log('asche');
    const res = await axios.post(
      `/api/action/editAction/${id}`,
      formData,
      config
    );
    dispatch({
      type: ADD_ACTION,
      payload: res.data
    });
    dispatch(getNextAction(res.data._id));
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getContactActions = id => async dispatch => {
  try {
    const res = await axios.get(`/api/action/contactID/${id}`);
    dispatch({
      type: GET_ACTIONS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getNextAction = id => async dispatch => {
  try {
    const res = await axios.get(`/api/action/nextAction/${id}`);
    dispatch({
      type: GET_ACTION,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getMyActionsByTime = () => async dispatch => {
  try {
    const res = await axios.get('/api/action/actionsByOperateTime');
    dispatch({
      type: GET_ACTIONS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getMyActionsByDate = () => async dispatch => {
  try {
    const res = await axios.get('/api/action/actionsByCreateDate');
    dispatch({
      type: GET_ACTIONS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const deleteAction = (formData, id) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.post(
      `/api/action/deleteAction/${id}`,
      formData,
      config
    );
    dispatch({
      type: DELETE_ACTION,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};



// WEBPACK FOOTER //
// ./src/actions/action.js